import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const LogoutIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 29.3327H6.66667C5.19391 29.3327 4 28.1388 4 26.666V5.33268C4 3.85992 5.19391 2.66602 6.66667 2.66602H13.3333"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6667 21.3327L28 15.9993L22.6667 10.666"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 16H12"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoutIcon;
